import { Env } from "./ConfigInterface";

const gingcoClientId =
        process.env.REACT_APP_GINGCO_CLIENT_ID || "me-at-eon-test";

export const AGGREGATION_SIZE: number = 1000;

export type OtherConfig = {
        snowClientId: string;
        appIndex: string;
        enhancedAppIndex: string;
        semanticAppIndex: string;
        indicies: string;
        gingcoClientId: string;
        AiAccess: string[];
        featureEnabledForUser: string[];
        snowClientIdLiveAgentChat: string;
        genAiApiBaseUrl: string;
        meAtEonContactEmail: string;
        azureBlobUrl: string;
        semanticKbServiceNowIndex: string[];
        isHigherEnv?: boolean;
        semanticOfficeBuddyIndex: string;
        itSupportIndex: string[];
        eonKnowledgeBaseIndex: string;
        semanticHrIndex: string;
        sharepointDsoDppublicDev: string;
        semanticConfluenceItsmIndex: string;
        nexthinkIndex: string;
        nexthinkTeamsIndex: string;
        compassIndex: string;
        semanticCompassIndex: string;
        enhancedOrderItApiIndex: string;
        enhancedServicenowIndex: string;
}

const otherConfigs: Record<Env, OtherConfig> = {
        local: {
                snowClientId: "5ab0593c7a9444cb845e8b13f7610baf",
                appIndex: "apps-dev",
                enhancedAppIndex: "apps-dev-enhanced",
                semanticAppIndex: "semantic-apps-dev",
                indicies:
                        "apps-dev,jira-prod,confluence-prod,gitlab-prod,mygenius-api,order-it-api",
                gingcoClientId,
                AiAccess: ["ME8EON_POC_USERS", "ME8EON_POC_MANAGERS"],
                featureEnabledForUser: ["Beta Version"],
                snowClientIdLiveAgentChat: "65cd92c89b65465884bc3d0395ecef55",
                genAiApiBaseUrl: "https://genai-api.eon.com",
                meAtEonContactEmail: "myhelp@eon.com",
                azureBlobUrl: "https://snowkbforme8eon.blob.core.windows.net",
                semanticKbServiceNowIndex: ["semantic-kb-servicenow-dev2", "questionator-office-buddy-itsm-dev"],
                semanticOfficeBuddyIndex: "questionator-office-buddy-hr-admin-dev",
                itSupportIndex: ["servicenow-dev", "office-buddy-search-itsm-dev"],
                eonKnowledgeBaseIndex: "office-buddy-search-hr-admin-dev",
                semanticHrIndex: "semantic-hr-dev",
                sharepointDsoDppublicDev: "ai-sharepoint-dso-dppublic-dev",
                semanticConfluenceItsmIndex: "semantic-confluence-itsm-dev",
                nexthinkIndex: "nexthink-dev",
                nexthinkTeamsIndex: "nexthink-teams-dev",
                compassIndex: "compass-prod",
                semanticCompassIndex: "semantic-compass-prod-v2",
                enhancedOrderItApiIndex: "order-it-api-price-enhanced, servicenow-dev-enhanced",
                enhancedServicenowIndex: "servicenow-dev-enhanced"
        },
        dev: {
                snowClientId: "5ab0593c7a9444cb845e8b13f7610baf",
                appIndex: "apps-dev",
                enhancedAppIndex: "apps-dev-enhanced",
                semanticAppIndex: "semantic-apps-dev",
                indicies:
                        "jira-prod,confluence-prod,gitlab-prod,mygenius-api,order-it-api",
                gingcoClientId,
                AiAccess: ["ME8EON_POC_USERS", "ME8EON_POC_MANAGERS"],
                featureEnabledForUser: ["Beta Version"],
                snowClientIdLiveAgentChat: "65cd92c89b65465884bc3d0395ecef55",
                genAiApiBaseUrl: "https://genai-api.eon.com",
                meAtEonContactEmail: "myhelp@eon.com",
                azureBlobUrl: "https://snowkbforme8eon.blob.core.windows.net",
                semanticKbServiceNowIndex: ["semantic-kb-servicenow-dev2", "questionator-office-buddy-itsm-dev"],
                semanticOfficeBuddyIndex: "questionator-office-buddy-hr-admin-dev",
                itSupportIndex: ["servicenow-dev", "office-buddy-search-itsm-dev"],
                eonKnowledgeBaseIndex: "office-buddy-search-hr-admin-dev",
                semanticHrIndex: "semantic-hr-dev",
                sharepointDsoDppublicDev: "ai-sharepoint-dso-dppublic-dev",
                semanticConfluenceItsmIndex: "semantic-confluence-itsm-dev",
                nexthinkIndex: "nexthink-dev",
                nexthinkTeamsIndex: "nexthink-teams-dev",
                compassIndex: "compass-prod",
                semanticCompassIndex: "semantic-compass-prod-v2",
                enhancedOrderItApiIndex: "order-it-api-price-enhanced, servicenow-dev-enhanced",
                enhancedServicenowIndex: "servicenow-dev-enhanced"
        },
        qa: {
                snowClientId: "25a0dab6ab914e7a962cff0f47ceb0df",
                appIndex: "apps-dev",
                enhancedAppIndex: "apps-dev-enhanced",
                semanticAppIndex: "semantic-apps-dev",
                indicies:
                        "jira-prod,confluence-prod,gitlab-prod,mygenius-api,order-it-api",
                gingcoClientId,
                AiAccess: ["ME8EON_POC_USERS", "ME8EON_POC_MANAGERS"],
                featureEnabledForUser: ["Beta Version"],
                snowClientIdLiveAgentChat: "d1588b7cc9654195bb724e2efa5176e4",
                genAiApiBaseUrl: "https://genai-api.eon.com",
                meAtEonContactEmail: "myhelp@eon.com",
                azureBlobUrl: "https://snowkbforme8eon.blob.core.windows.net",
                semanticKbServiceNowIndex: ["semantic-kb-servicenow-dev2", "questionator-office-buddy-itsm-dev"],
                semanticOfficeBuddyIndex: "questionator-office-buddy-hr-admin-dev",
                itSupportIndex: ["servicenow-dev", "office-buddy-search-itsm-dev"],
                eonKnowledgeBaseIndex: "office-buddy-search-hr-admin-dev",
                semanticHrIndex: "semantic-hr-dev",
                sharepointDsoDppublicDev: "ai-sharepoint-dso-dppublic-dev",
                semanticConfluenceItsmIndex: "semantic-confluence-itsm-dev",
                nexthinkIndex: "nexthink-dev",
                nexthinkTeamsIndex: "nexthink-teams-dev",
                compassIndex: "compass-prod",
                semanticCompassIndex: "semantic-compass-prod-v2",
                enhancedOrderItApiIndex: "order-it-api-price-enhanced, servicenow-dev-enhanced",
                enhancedServicenowIndex: "servicenow-dev-enhanced"
        },
        pp: {
                snowClientId: "25a0dab6ab914e7a962cff0f47ceb0df",
                appIndex: "apps-prod",
                enhancedAppIndex: "apps-prod-enhanced",
                semanticAppIndex: "semantic-apps-prod",
                indicies: "jira-prod,confluence-prod,gitlab-prod,mygenius-api",
                gingcoClientId,
                AiAccess: ["APL213643-me8eon-Ai-assistance", "APL213643-me8eon-User"],
                featureEnabledForUser: ["Beta Version"],
                snowClientIdLiveAgentChat: "d1588b7cc9654195bb724e2efa5176e4",
                genAiApiBaseUrl: "https://genai-api.eon.com",
                meAtEonContactEmail: "myhelp@eon.com",
                azureBlobUrl: "https://snowkbforme8eon.blob.core.windows.net",
                isHigherEnv: true,
                semanticKbServiceNowIndex: ["semantic-kb-servicenow-prod2", "questionator-office-buddy-itsm-prod"],
                semanticOfficeBuddyIndex: "questionator-office-buddy-hr-admin-prod",
                itSupportIndex: ["servicenow-prod", "office-buddy-search-itsm-prod"],
                eonKnowledgeBaseIndex: "office-buddy-search-hr-admin-prod",
                semanticHrIndex: "semantic-hr-prod",
                semanticConfluenceItsmIndex: "semantic-confluence-itsm-dev",
                nexthinkIndex: "nexthink-prod",
                nexthinkTeamsIndex: "nexthink-teams-prod",
                compassIndex: "compass-prod",
                semanticCompassIndex: "semantic-compass-prod-v2",
                sharepointDsoDppublicDev: "ai-sharepoint-dso-dppublic-dev",
                enhancedOrderItApiIndex: "order-it-api-price-enhanced, servicenow-prod-enhanced",
                enhancedServicenowIndex: "servicenow-prod-enhanced"
        },
        prod: {
                snowClientId: "620785b3bab846e8acaaefd44bf53234",
                appIndex: "apps-prod",
                enhancedAppIndex: "apps-prod-enhanced",
                semanticAppIndex: "semantic-apps-prod",
                indicies: "jira-prod,confluence-prod,gitlab-prod,mygenius-api",
                gingcoClientId,
                AiAccess: ["APL213643-me8eon-User"],
                featureEnabledForUser: ["Beta Version"],
                snowClientIdLiveAgentChat: "f41ea50929e94393b7c105b35e996c7d",
                genAiApiBaseUrl: "https://genai-api.eon.com",
                meAtEonContactEmail: "myhelp@eon.com",
                azureBlobUrl: "https://snowkbforme8eon.blob.core.windows.net",
                isHigherEnv: true,
                semanticKbServiceNowIndex: ["semantic-kb-servicenow-prod2", "questionator-office-buddy-itsm-prod"],
                semanticOfficeBuddyIndex: "questionator-office-buddy-hr-admin-prod",
                itSupportIndex: ["servicenow-prod", "office-buddy-search-itsm-prod"],
                eonKnowledgeBaseIndex: "office-buddy-search-hr-admin-prod",
                semanticHrIndex: "semantic-hr-prod",
                semanticConfluenceItsmIndex: "semantic-confluence-itsm-dev",
                nexthinkIndex: "nexthink-prod",
                nexthinkTeamsIndex: "nexthink-teams-prod",
                compassIndex: "compass-prod",
                semanticCompassIndex: "semantic-compass-prod-v2",
                sharepointDsoDppublicDev: "ai-sharepoint-dso-dppublic-dev",
                enhancedOrderItApiIndex: "order-it-api-price-enhanced, servicenow-prod-enhanced",
                enhancedServicenowIndex: "servicenow-prod-enhanced"
        },
};

export default otherConfigs;
